















import { Component, Prop, Vue } from 'vue-property-decorator';
import FilterOption from '@/models/FilterOption';
import { FilterAction } from '@/store/actions';
import { SearchGetter } from '@/store/getters';
import Filter from '@/models/Filter';
import HelperService from '@/services/HelperService';

@Component({
  name: 'filter-option-component',
})
export default class FilterOptionComponent extends Vue {
  @Prop()
  private option: FilterOption | undefined;

  @Prop()
  private filter: Filter | undefined;

  private helperService = HelperService;

  get isLoading(): boolean {
    return this.$store.getters[SearchGetter.IsLoading];
  }

  private handleChange() {
    if (this.option) {
      this.option.isChecked = !this.option?.isChecked;
      this.$store.dispatch(FilterAction.ToggleFilterOption, { filterOption: this.option });
    }
  }

  private get translatedFilter(): string {
    return this.option ? this.helperService.translatedFilterOption(this.option) : '';
  }
}
